// extracted by mini-css-extract-plugin
export default {"fullscreen":"JtyChKdMRXJKNDq2o1sT","buttons":"jEMeUVG_nMVW5wjON86A","carousel":"BDJ8H5lwHEzlVCG1aDwV","slide":"ddiV8ekFpX1JirR3ANgQ","prompt":"dvjBlnf91szqtQUcjrmr"};